import React from "react";
import { StatusAvatarGroup } from "./StatusAvatarGroup";

// Pure — the "Players" column header with team-wide status counts.
export const PlayerHeaderView = ({ counts = [] }) => (
    <div
        className="stv2-tracker-header-card"
        style={counts.length > 0 ? { justifyContent: "space-between" } : { justifyContent: "flex-start" }}
    >
        <div className="stv2-tracker-header-card-header-txt">Players</div>
        {counts.length > 0 && (
            <div className="stv2-tracker-header-card-status-count">
                <StatusAvatarGroup counts={counts} keyPrefix="header" />
            </div>
        )}
    </div>
);
